import React from "react";
import { Button, Result, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const ErrorPage = ({ title, description, reset, action }) => {
	const { Title } = Typography;
	const navigate = useNavigate();

	const defaultMsg = {
		title: "Page Not Found",
		description: "Sorry, the page you requested cannot be found.",
	};

	const onClickBack = () => {
		if (action) {
			reset();
			action();
		} else {
			navigate(-1);
		}

		setTimeout(() => {
			window.location.reload();
		}, 100);
	};

	return (
		<Result
			status='error'
			title={<Title level={1}>{title ?? defaultMsg.title}</Title>}
			subTitle={
				<Title type='secondary' level={3}>
					{description ?? defaultMsg.description}
				</Title>
			}
			extra={
				<Button type='primary' danger onClick={onClickBack}>
					{title === "Unauthorized" ? "Go to Login" : "Go Back"}
				</Button>
			}
		/>
	);
};

export default ErrorPage;
